const ICONS = {
  instagram: "fa-brands fa-instagram",
  tiktok: "fa-brands fa-tiktok",
  spotify: "fa-brands fa-spotify",
  soundcloud: "fa-brands fa-soundcloud",
  youtube: "fa-brands fa-youtube",
  x: "fa-brands fa-x-twitter",
  apple: "fa-brands fa-apple",
  website: "fa-solid fa-globe",
};

export const LINK_KEYS = Object.keys(ICONS);

export const SocialLinks = ({ links = {}, testPrefix, size = "w-10 h-10" }) => (
  <div className="flex flex-wrap gap-2">
    {Object.entries(links || {})
      .filter(([, url]) => url)
      .map(([k, url]) => (
        <a
          key={k}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={k}
          data-testid={`${testPrefix}-${k}-link`}
          className={`${size} grid place-items-center border border-white/25 bg-black/60 backdrop-blur-md text-[#F4F4F6] hover:bg-[#56ED4A] hover:text-black hover:border-[#56ED4A] transition-colors duration-200`}
        >
          <i className={ICONS[k] || ICONS.website} />
        </a>
      ))}
  </div>
);
